module.exports = __webpack_public_path__ + "static/sonae-f02240428bafb6969dff94959d26b61b.svg";